import { render, staticRenderFns } from "./FrameworkAgreement.vue?vue&type=template&id=b1493dce&scoped=true"
import script from "./FrameworkAgreement.vue?vue&type=script&lang=ts"
export * from "./FrameworkAgreement.vue?vue&type=script&lang=ts"
import style0 from "./FrameworkAgreement.vue?vue&type=style&index=0&id=b1493dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1493dce",
  null
  
)

export default component.exports